import * as Sentry from '@sentry/angular';

export function initSentry() {
  Sentry.init({
    dsn: 'https://40774e148206c1de86b2aa33ed74ab97@o4509796022878208.ingest.de.sentry.io/4509796351213648',
    tracesSampleRate: 1.0,
    sendDefaultPii: true,
    environment: getSentryEnvironment(),
    integrations: [Sentry.replayIntegration()],
    replaysSessionSampleRate: 0.0,
    replaysOnErrorSampleRate: 1.0,
  });
  Sentry.setTag('platform', 'angular');
}

function getSentryEnvironment(): string {
  return window.location.hostname.includes('localhost')
    ? 'local'
    : window.location.hostname.includes('test')
      ? 'test'
      : 'prod';
}
